import Collection from 'lib/client/collections/collection'

class AppointmentStatuses extends Collection{
    create(options){
        return this.axios.post(`organizations/${this.props.currentOrganization.id}/appointment-statuses`, options);
    }
    update(options){
        const id = options.id
        delete options.id
        return this.axios.put(`organizations/${this.props.currentOrganization.id}/appointment-statuses/${id}`, options);
    }
    activate(options){
        return this.axios.put(`organizations/${this.props.currentOrganization.id}/appointment-statuses/activate`, options);
    }
    destroy(id){
        return this.axios.delete(`organizations/${this.props.currentOrganization.id}/appointment-statuses/${id}`);
    }
    fetch(options = {}){
        return this.axios.get(`organizations/${this.props.currentOrganization.id}/appointment-statuses`, options);
    }
}

export default AppointmentStatuses;